/* eslint-disable max-len */
import { serviceName } from '../resources/serviceConstants';
import {
  REPORT_PDF,
  REPORT_EXCEL,
  CERTIFICATION_MAP_REPORT_PDF,
  CERTIFICATION_MAP_REPORT_EXCEL,
  CERTIFICATION_OVERVIEW_DOWNLOAD_URL,
  STAFF_AUGMENTATION_DOWNLOAD_URL,
  RESOURCE__REQUIREMENT_REPORTS,
  STAFFING_PENDING_POSITIONS_REPORT,
  OPPORTUNITIES_REPORT_DOWNLOAD,
  GET_LOST_DROPPED_REPORT,
  CLOSURE_OVERVIEW_REPORT,
  GET_SALES_MEMBER_REPORT,
  PENDING_ONBOARDING_DOWNLOAD,
  GET_DELIVERY_MANAGER_REPORT,
  OVERALL_REPORT,
  PERMISSION_REPORT,
  USER_DATA_REPORT,
  HOME_DASHBOARD_EXPORT,
} from '../resources/endPoint';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';
import AxiosWrapper from '../http/AxiosWrapper';
import dayjs from 'dayjs';

const Wrapper = new AxiosWrapper();

const getDataFile = async (
  service,
  baseUrl,
  path,
  downloadName,
  contentType,
  isAuthTokenIncluded = false,
) => {
  try {
    const servicePort = appendServicePortToURL(service);
    const serviceURL = appendServiceNameToURL(service);

    const url
      = process.env.NODE_ENV === 'development'
        ? `${baseUrl}:${servicePort}${serviceURL}/api${path}`
        : `${baseUrl}${serviceURL}/api${path}`;
    const authToken = Wrapper.getAuthToken();
    const authorization = localStorage.getItem('userRolesToken');
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': contentType,
        token: authToken,
        ...(isAuthTokenIncluded && { Authorization: authorization }),
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = globalThis.URL.createObjectURL(blob);
    link.download = downloadName;
    link.click();
  } catch (error) {
    console.error(`Failed to download ${contentType}:`, error);
    throw new Error(`Failed to download ${contentType}: ` + error.message);
  }
};


const createTimestampedFilename = (baseName, extension) => {
  const now = new Date();
  const formattedDate = `${now.getFullYear()}${(now.getMonth() + 1)
    .toString()
    .padStart(2, '0')}${now.getDate()
    .toString()
    .padStart(2, '0')}${now.getHours()
    .toString()
    .padStart(2, '0')}${now.getMinutes()
    .toString()
    .padStart(2, '0')}`;
  return `${baseName}-${formattedDate}.${extension}`;
};

export const getRolesDataPdf = async () => {
  const service = serviceName.ROLES_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = REPORT_PDF;
  const downloadName = 'role_master.pdf';

  await getDataFile(service, baseUrl, path, downloadName, 'application/pdf');
};

export const getSkillsDataPdf = async () => {
  const service = serviceName.SKILLS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = REPORT_PDF;
  const downloadName = 'skill_master.pdf';

  await getDataFile(service, baseUrl, path, downloadName, 'application/pdf');
};

export const getCertificationsDataPdf = async () => {
  const service = serviceName.CERTIFICATIONS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = REPORT_PDF;
  const downloadName = 'certifications_master.pdf';

  await getDataFile(service, baseUrl, path, downloadName, 'application/pdf');
};

export const getCertificationMapDataPdf = async () => {
  const service = serviceName.CERTIFICATIONS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = CERTIFICATION_MAP_REPORT_PDF;
  const downloadName = 'map_certifications.pdf';

  await getDataFile(service, baseUrl, path, downloadName, 'application/pdf');
};

export const getCertificationOverviewPdf = async (selectedYear) => {
  const service = serviceName.CERTIFICATIONS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = `${CERTIFICATION_OVERVIEW_DOWNLOAD_URL}?format=pdf&year=${selectedYear}`;
  const downloadName = 'certification_overview.pdf';

  await getDataFile(service, baseUrl, path, downloadName, 'application/pdf');
};

export const getResourceRequirementReportsPdf = async (id) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = `${RESOURCE__REQUIREMENT_REPORTS}?format=pdf&staffingId=${id}`;
  const downloadName = createTimestampedFilename('Requirement-resourcing', 'pdf');

  await getDataFile(service, baseUrl, path, downloadName, 'application/pdf');
};

export const getRolesDataExcel = async () => {
  const service = serviceName.ROLES_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = REPORT_EXCEL;
  const downloadName = 'role_master.xlsx';

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getSkillsDataExcel = async () => {
  const service = serviceName.SKILLS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = REPORT_EXCEL;
  const downloadName = 'skill_master.xlsx';

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getCertificationsDataExcel = async () => {
  const service = serviceName.CERTIFICATIONS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = REPORT_EXCEL;
  const downloadName = 'certifications_master.xlsx';

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};
export const getStaffAugDataExcel = async () => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = STAFF_AUGMENTATION_DOWNLOAD_URL;
  const now = new Date();
  const timestamp = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0')
   + String(now.getDate()).padStart(2, '0')
   + String(now.getHours()).padStart(2, '0')
   + String(now.getMinutes()).padStart(2, '0');

  const downloadName = `staff_augmentation_${timestamp}.xlsx`;

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};


export const getMapCertificationDataExcel = async () => {
  const service = serviceName.CERTIFICATIONS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = CERTIFICATION_MAP_REPORT_EXCEL;
  const downloadName = 'map_certifications.xlsx';

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getHomeDashboardExport = async (reportType = 'all') => {
  const service = serviceName.PROJECT_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = `${HOME_DASHBOARD_EXPORT}?reportType=${encodeURIComponent(reportType)}`;
  const downloadName = createTimestampedFilename(`home-dashboard-${reportType}`, 'xlsx');

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getCertificationOverviewExcel = async (selectedYear) => {
  const service = serviceName.CERTIFICATIONS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = `${CERTIFICATION_OVERVIEW_DOWNLOAD_URL}?format=excel&year=${selectedYear}`;
  const downloadName = 'certification_overview.xlsx';

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getResourceRequirementReportsExcel = async (id) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = `${RESOURCE__REQUIREMENT_REPORTS}?format=excel&staffingId=${id}`;
  const downloadName = createTimestampedFilename('Requirement-resourcing', 'xlsx');

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};


export const getPendingPositionReportsExcel = async (startDate, endDate) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;

  let path = `${STAFFING_PENDING_POSITIONS_REPORT}?format=excel`;

  if (startDate) {
    const formattedFromDate = dayjs(startDate).format('YYYY-MM-DD');
    path += `&fromDate=${formattedFromDate}`;
  }

  if (endDate) {
    const formattedEndDate = dayjs(endDate).format('YYYY-MM-DD');
    path += `&toDate=${formattedEndDate}`;
  }

  const downloadName = createTimestampedFilename('pending_positions_report', 'xlsx');

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getOpportunitiesOverviewReport = async (startDate, endDate) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrlPath = process.env.REACT_APP_API_URL;

  let path = `${OPPORTUNITIES_REPORT_DOWNLOAD}?format=excel`;

  if (startDate) {
    const formattedFromDate = dayjs(startDate).format('YYYY-MM-DD');
    path += `&startDate=${formattedFromDate}`;
  }

  if (endDate) {
    const formattedEndDate = dayjs(endDate).format('YYYY-MM-DD');
    path += `&endDate=${formattedEndDate}`;
  }

  const downloadName = createTimestampedFilename('opportunities_overview_report', 'xlsx');

  await getDataFile(
    service,
    baseUrlPath,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getstaffLostDropReportExcel = async (startDate, endDate) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = `${GET_LOST_DROPPED_REPORT}?format=excel&startDate=${startDate}&endDate=${endDate}`;
  const downloadName = createTimestampedFilename('staff_lost_dropped_report', 'xlsx');

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getClosureReportExcel = async (fromDate, toDate) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;

  let path = `${CLOSURE_OVERVIEW_REPORT}?format=excel`;

  if (fromDate) {
    const formattedFromDate = fromDate.toISOString().slice(0, 10);
    path += `&startDate=${formattedFromDate}`;
  }

  if (toDate) {
    const formattedToDate = toDate.toISOString().slice(0, 10);
    path += `&endDate=${formattedToDate}`;
  }

  const downloadName = createTimestampedFilename('closure_this_week_report', 'xlsx');

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getSalesMemberWiseReportExcel = async (startDate, endDate) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = `${GET_SALES_MEMBER_REPORT}?format=excel&startDate=${startDate}&endDate=${endDate}`;
  const downloadName = createTimestampedFilename('sales_member_wise_data_report', 'xlsx');

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getPendingOnboardingReportExcel = async (fromDate, toDate) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;

  let path = `${PENDING_ONBOARDING_DOWNLOAD}?format=excel`;

  if (fromDate) {
    const formattedFromDate = fromDate.toISOString().slice(0, 10);
    path += `&startDate=${formattedFromDate}`;
  }

  if (toDate) {
    const formattedToDate = toDate.toISOString().slice(0, 10);
    path += `&endDate=${formattedToDate}`;
  }

  const downloadName = createTimestampedFilename('resource_pending_onboarding', 'xlsx');

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getDeliveryManagerWiseReportExcel = async (startDate, endDate) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = `${GET_DELIVERY_MANAGER_REPORT}?format=excel&startDate=${startDate}&endDate=${endDate}`;
  const downloadName = createTimestampedFilename('delivery_manager_wise_data', 'xlsx');

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  );
};

export const getOverallReportExcel = async (params = {}) => {
  const service = serviceName.STAFF_AUGMENTATION_MS;
  const baseUrl = process.env.REACT_APP_API_URL;

  let path = `${OVERALL_REPORT}`;
  let downloadName = '';
  let contentType = '';

  const { dealType, startDate, endDate, format, shortNameofReports = [] } = params;


  const queryParams = [];
  if (format) {
    queryParams.push(`format=${format}`);
  }

  if (startDate) queryParams.push(`startDate=${startDate}`);
  if (endDate) queryParams.push(`endDate=${endDate}`);

  if (Array.isArray(dealType) && dealType.length > 0) {
    dealType.forEach(dt => {
      queryParams.push(`dealType=${dt}`);
    });
  }

  shortNameofReports.forEach(reportType => {
    queryParams.push(`reportsType=${reportType}`);
  });

  if (queryParams.length > 0) {
    path += `?${queryParams.join('&')}`;
  }

  if (format === 'pdf'){
    downloadName = createTimestampedFilename('Requirement-resourcing', 'pdf');
    contentType = 'application/pdf';
  } else {
    downloadName = createTimestampedFilename('overall_report', 'xlsx');
    contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    contentType,
  );
};

export const getPermissionDataExcel = async (params = {}) => {
  const service = serviceName.ROLES_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  let path = PERMISSION_REPORT;
  let downloadName = 'permission_report.xlsx';

  if (params && (params.email || params.employeeId)) {
    const queryParams = new URLSearchParams();
    if (params.email) queryParams.append('email', params.email);
    if (params.employeeId) queryParams.append('employeeId', params.employeeId);
    if (params.name) queryParams.append('name', params.name);
    if (params.vertical) queryParams.append('vertical', params.vertical);
    if (params.designation) queryParams.append('designation', params.designation);
    if (params.department) queryParams.append('department', params.department);
    if (params.status) queryParams.append('status', params.status);

    path = `${PERMISSION_REPORT}?${queryParams.toString()}`;
    const safeId = String(params.employeeId || 'report').replace(/[^a-zA-Z0-9_-]/g, '_');
    downloadName = `employee_permissions_${safeId}.xlsx`;
  } else if (params && (params.roleId || params.roleName || params.role)) {
    const queryParams = new URLSearchParams();
    if (params.roleId) queryParams.append('roleId', params.roleId);
    if (params.roleName) queryParams.append('roleName', params.roleName);
    if (params.role) queryParams.append('role', params.role);

    path = `${PERMISSION_REPORT}?${queryParams.toString()}`;
    const safeRoleName = String(params.roleName || params.role || 'role').replace(/[^a-zA-Z0-9_-]/g, '_');
    downloadName = `${safeRoleName}_permission_report.xlsx`;
  }

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    true,
  );
};

export const getUserDataReportExcel = async (reportType) => {
  const service = serviceName.ROLES_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = `${USER_DATA_REPORT}?report-type=${reportType}`;
  const downloadName = 'user_data_report.xlsx';

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    true,
  );
};
